export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-40894831ea9341c0ed96.worker.js");
}
